module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-BoldItalic-3ce9e61b26be5d2e9c9e06d4e367f96c.woff";